import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GameResponseKeys } from './../../../../api/Constants';
import { getGameRooms } from '../';
import { setNewGames, setFeaturedGames, setSlotGames, setTableGames, setVipGames } from '../../../actions/game';
import { showVipAccessModal, setVipRoomUnlocked } from '../../../actions/consumables';
import Logger from '../../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import ERROR_CODE from '../../../../utils/errorCodes';
import store from '../../../../state/store';
import transformObjectArrayResponse from '../../../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../../../utils/transformObjectResponseKeys';
export var getGameRoomResponseHandler = function getGameRoomResponseHandler(gamelist) {
  var response = _objectSpread({}, gamelist);

  response.featured = transformObjectArrayResponse(response.featured);
  response.new_games = transformObjectArrayResponse(response.new_games);
  response.slots = transformObjectArrayResponse(response.slots);
  response.table = transformObjectArrayResponse(response.table);
  response.configurable_vip = transformObjectArrayResponse(response.configurable_vip);
  response.featured.forEach(function (game, index) {
    response.featured[index] = transformObjectResponseKeys(game, GameResponseKeys);
  });
  response.new_games.forEach(function (game, index) {
    response.new_games[index] = transformObjectResponseKeys(game, GameResponseKeys);
  });
  response.slots.forEach(function (item) {
    item.gameRoomBalanceThreshold = _objectSpread(_objectSpread({}, item.gameRoomBalanceThreshold), {}, {
      amount: parseInt(item.gameRoomBalanceThreshold.amount || 0)
    });
    item.games = transformObjectArrayResponse(item.games);
    item.games.forEach(function (game, index) {
      item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
    });
  });
  response.table.forEach(function (item) {
    item.gameRoomBalanceThreshold = _objectSpread(_objectSpread({}, item.gameRoomBalanceThreshold), {}, {
      amount: parseInt(item.gameRoomBalanceThreshold.amount || 0)
    });
    item.games = transformObjectArrayResponse(item.games);
    item.games.forEach(function (game, index) {
      item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
    });
  });
  response.configurable_vip.forEach(function (item) {
    item.gameRoomBalanceThreshold = _objectSpread(_objectSpread({}, item.gameRoomBalanceThreshold), {}, {
      amount: parseInt(item.gameRoomBalanceThreshold.amount || 0)
    });
    item.games = transformObjectArrayResponse(item.games);
    item.news = transformObjectArrayResponse(item.news);
    item.games.forEach(function (game, index) {
      item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
    });
  });
  return response;
};
export var updateGameRooms = function updateGameRooms(gamesList, dispatch) {
  var newGames = gamesList.new_games;
  var featuredGames = gamesList.featured;
  var slotGamesRoom = gamesList.slots;
  var tableGamesRoom = gamesList.table;
  var vipGamesRoom = gamesList.configurable_vip;
  if (newGames) dispatch(setNewGames(newGames));
  if (featuredGames) dispatch(setFeaturedGames(featuredGames));
  if (slotGamesRoom) dispatch(setSlotGames(slotGamesRoom));
  if (tableGamesRoom) dispatch(setTableGames(tableGamesRoom));

  if (vipGamesRoom) {
    dispatch(setVipGames(vipGamesRoom));
    dispatch(showVipAccessModal(true));
    dispatch(setVipRoomUnlocked(vipGamesRoom[0].can_enter_room));
  }
};
export var fetchGameRooms = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var forceRefetch,
        pollingInterval,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            forceRefetch = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            pollingInterval = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            _context.prev = 2;
            _context.next = 5;
            return store.dispatch(getGameRooms.initiate('fetchGameRooms', _objectSpread({
              forceRefetch: forceRefetch
            }, pollingInterval && {
              subscriptionOptions: {
                pollingInterval: 120000
              }
            }))).unwrap();

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
              code: ERROR_CODE.LOBBY_OVERLAY_FETCH_GAME_ROOMS_FAIL
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function fetchGameRooms() {
    return _ref.apply(this, arguments);
  };
}();